import React, { useState, useEffect, useRef, useCallback } from 'react';
import { newShareLink } from '../../utils/shareLink';
import DownloadRequestFormModal from '../../components/DownloadRequestFormModal';
import DownloadSelectionBar from '../../components/DownloadSelectionBar';
import { runDownloadRequestSubmit } from '../../utils/runDownloadRequestSubmit';
import { canDownloadDirectly } from '../../utils/downloadAccess';
import { mergeSearchPage } from '../../utils/mergeSearchPage';
import { MSG } from "../../constants/toastMessages";
import { Virtuoso } from 'react-virtuoso';
import { HiDownload } from "react-icons/hi";
import MediaPreview from '../../components/MediaPreview';
import LargeBundleNote from '../../components/LargeBundleNote';
import { apiCallingPost, prepareDownload } from '../../api/services';
import useDownloadLock from '../../hooks/useDownloadLock';
import startBrowserDownload from '../../utils/startBrowserDownload';
import { toast } from 'react-toastify';
import Loader from "../../assets/images/loader.gif"
import { useSelector, useDispatch, useStore } from "react-redux";
import {
  setFileType, setSearchText, setOffsetTag, setShowMoreTag,
  setTagList, setTagNameFlag
} from '../../redux/reducers/commonSlice';
import { setSelectedQuality, setCurrentPlaybackRate, setViewType, setVolume, setIsMuted } from '../../redux/reducers/commonSliceWhiteList';
import { toggleRow, removeVideo, clearSelection, selectSelectedItems, selectSelectedVideoIds, selectSelectedVideos } from '../../redux/reducers/selectionSlice';
import ListUpload from './show-more-list-edit';
import VideoCard from '../../components/VideoCard';
import { FiLink, FiMail } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import { BiDownload, BiFile } from "react-icons/bi";
import { FaDownload } from "react-icons/fa";

// Stable component reference for Virtuoso list view — defined outside the component
// so it is never recreated on re-render (would cause virtuoso to remount the list).
const ListItem = React.forwardRef((props, ref) => (
  <div ref={ref} {...props} className="list-sub col" />
));

function ListShowAll(props) {
  const dispatch = useDispatch();
  const store = useStore();
  const { fileType, searchText, offsetTag, pageSizeTag, showMoreTag,
    tagList, totalCountTag, loadingTag, searchType, tagNames, tagNameFlag, tagListIsFallback } = useSelector((state) => state.commonData)
  const { selectedQuality, currentPlaybackRate, speeds, viewType, volume, isMuted } = useSelector((state) => state.commonDataWhiteList)
  const videoRefs = useRef({});
  const urlRef = useRef('');
  const virtuosoRef = useRef(null);
  const [tagListMore, setTagListMore] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [tagPopupFlag, setTagPopupFlag] = useState(false);
  const [pipVideoId, setPipVideoId] = useState(null);
  const [popupList, setPopupList] = useState(false);
  const [selectData, setSelectData] = useState([]);
  const [selectIndex, setSelectIndex] = useState("");
  const [mode, setMode] = useState("");
  const [isShareLink, setIsShareLink] = useState(false)
  const [shareMode, setShareMode] = useState("Viewer")
  const [videoIDsIndividual, setVideoIDsIndividual] = useState([]);
  const [isDownload, setIsDownload] = useState(false)
  const [isOriginalCheck, setIsOriginalCheck] = useState(false);
  const [isMp4Check, setIsMp4check] = useState(false)
  const [shareRecipientEmail, setShareRecipientEmail] = useState("")
  const [shareMessage, setShareMessage] = useState("")
  const [isVideoFormatSelect, setIsVideoFormatSelect] = useState(true)
  const [hasVideo, setHasVideo] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [popupShareStates, setPopupShareStates] = useState({});
  const [popupReject, setPopupReject] = useState(false);
  const [isMultipleDownload, setIsMultipleDownload] = useState(false);
  // staff / full access download outright; everyone else requests (see downloadAccess.js)
  const canDownloadDirect = canDownloadDirectly(props.userData);
  // #9: mandatory download-request form state. { count, submit }; submit(details) POSTs.
  const [downloadRequestForm, setDownloadRequestForm] = useState(null);
  // The files the bulk download modal shows/downloads (the approved subset of
  // the selection, or all of it) — separate from the selection itself.
  const [downloadSet, setDownloadSet] = useState([]);
  const [selectedQualities, setSelectedQualities] = useState({});
  const [totalFileSize, setTotalFileSize] = useState(0)
  const [totalFileSizeMb, setTotalFileSizeMb] = useState(0)
  const [isDownloadBtn, setIsDownloadBtn] = useState(false)
  const [rejectData, setRejectData] = useState([]);
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);

  // The selection lives in the store (selectionSlice) so it survives this
  // component unmounting and a search replacing the rows. These are the
  // derived shapes the code below always consumed.
  const selectedItems = useSelector(selectSelectedItems);
  const selectedVideoIds = useSelector(selectSelectedVideoIds);
  const selectedDownloadVideoALL = useSelector(selectSelectedVideos);
  useEffect(() => {
    // offsetTag===0 -> new search (replace); otherwise append. mergeSearchPage
    // dedupes by video id: this effect also fires when offsetTag bumps BEFORE the
    // next page's data returns, re-firing with a stale tagList (the previous page)
    // — deduping makes that re-append a no-op instead of duplicate cards (the
    // "duplicate search results" the client saw for multi-page queries).
    setTagListMore(prev => mergeSearchPage(prev, tagList, offsetTag));
  }, [tagList, offsetTag]);

  // Scroll to top when offset resets (tab switch, new search)
  useEffect(() => {
    if (offsetTag === 0) {
      window.scrollTo(0, 0);
    }
  }, [offsetTag]);

  // Load next page when virtuoso reaches the end of the rendered list
  const handleLoadMore = useCallback(() => {
    if (!loadingTag && totalCountTag > offsetTag + pageSizeTag) {
      dispatch(setOffsetTag(offsetTag + pageSizeTag));
    }
  }, [loadingTag, totalCountTag, offsetTag, pageSizeTag, dispatch]);

  const isStaff = ['Admin', 'Super_admin', 'APPROVER'].includes(props.userData?.roleDisplayName);
  // Share the whole selection (selection bar). Only staff can create shares.
  const shareSelection = () => {
    setVideoIDsIndividual([]);
    urlRef.current = newShareLink();
    setIsShareLink(true);
    setHasVideo(selectedItems.some(item => item.type_flag === 2));
  };

  const renderVideoCard = (i) => {
    const data = tagListMore[i];
    if (!data) return null;
    return (
      <VideoCard
        data={data}
        index={i}
        videoRefsMap={videoRefs}
        viewType={viewType}
        selectedQuality={selectedQuality}
        currentPlaybackRate={currentPlaybackRate}
        volume={volume}
        isMuted={isMuted}
        searchType={searchType}
        isAuthenticated={props.isAuthenticated}
        userData={props.userData}
        isPiP={pipVideoId === data.id}
        isChecked={data.video_id == data.id ? selectedVideoIds.includes(data.video_id) : selectedItems.some(item => item.id === data.id && item.video_id === data.video_id)}
        speeds={speeds}
        onPopupTagShow={popupTagShow}
        onTogglePiP={handlePiP}
        onCheckboxChange={handleCheckboxChange}
        onListPopup={listPopup}
        onDelete={handleDelete}
        onShare={handleShare}
        showShare={selectedVideoIds.length === 0}
        onVolumeChange={handleVolumeChange}
        onQualityChange={handleQualityChange}
        onPlaybackRateChange={handlePlaybackRateChange}
      />
    );
  };

  // Row-based grid rendering: each Virtuoso item is a complete row of 3 cards.
  // This avoids VirtuosoGrid's partial-row and variable-height measurement issues.
  const GRID_COLS = 3;
  const gridRowCount = Math.ceil(tagListMore.length / GRID_COLS);
  const renderGridRow = (rowIndex) => {
    const startIdx = rowIndex * GRID_COLS;
    return (
      <div className="row g-4 row-cols-1 row-cols-md-2 row-cols-lg-3">
        {Array.from({ length: GRID_COLS }, (_, col) => {
          const idx = startIdx + col;
          if (idx >= tagListMore.length) {
            return <div key={`empty-${col}`} className="list-sub col" style={{ visibility: 'hidden' }} />;
          }
          return (
            <div key={tagListMore[idx]?.id || idx} className="list-sub col">
              {renderVideoCard(idx)}
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    const total = getTotalSizeInMB(downloadSet);
    const formattedSize = getTotalSizeMB(total);
    setTotalFileSize(formattedSize)
    setTotalFileSizeMb(Number(total))
  }, [downloadSet]);
  const getTotalSizeInMB = (videoArray) => {
    let totalSize = 0;
    const qualityUpdates = {};
    videoArray.forEach(video => {
      let sizeInMB;
      if (video.download_original || video.download_original === "" || canDownloadDirect) {
        sizeInMB = parseFloat(video.size);
        qualityUpdates[video.video_id] = { quality: "Download Original", size: sizeInMB };
      } else if (Array.isArray(video.qualityvariants) && video.qualityvariants.length > 0) {
        sizeInMB = parseFloat(video.qualityvariants[0].qualityvideosize);
        qualityUpdates[video.video_id] = { quality: video.qualityvariants[0].qualitytype, size: sizeInMB };
      } else {
        sizeInMB = 0; // fallback
      }
      const sizeString = sizeInMB.toString().trim().toUpperCase();
      const value = parseFloat(sizeString.replace("MB", ""));
      totalSize += isNaN(value) ? 0 : value;
    });
    if (Object.keys(qualityUpdates).length > 0) {
      setSelectedQualities(prev => ({ ...prev, ...qualityUpdates }));
    }
    return totalSize.toFixed(2);
  };


  const handleQualityChange = useCallback((quality) => {
    dispatch(setSelectedQuality(quality));
  }, [dispatch]);

  const popupTagShow = useCallback((data) => {
    setSelectedData(data);
    setTagPopupFlag(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const handlePiP = useCallback(async (videoId) => {
    const playerInstance = videoRefs.current[videoId];
    const videoElement = playerInstance?.getVideoElement();
    if (!videoElement) return;

    if (!document.pictureInPictureElement) {
      try {
        await videoElement.requestPictureInPicture();
        setPipVideoId(videoId);
      } catch (error) {
        console.error('Failed to enter PiP:', error);
      }
    } else {
      try {
        await document.exitPictureInPicture();
        setPipVideoId(null);
      } catch (error) {
        console.error('Failed to exit PiP:', error);
      }
    }
  }, []);

  const handlePlaybackRateChange = useCallback((rate) => {
    dispatch(setCurrentPlaybackRate(rate));
  }, [dispatch]);

  const handleVolumeChange = useCallback((e) => {
    dispatch(setVolume(e.target.volume));
    dispatch(setIsMuted(e.target.muted));
  }, [dispatch]);

  const cancelpopup = () => {
    setTagPopupFlag(false);
    document.body.style.overflow = 'auto';
    setIsMultipleDownload(false)
    setSelectedQualities({})
    setIsDownloadBtn(false)
    setIsVideoFormatSelect(true)
    setShareMode("Viewer")
    // setSelecteddownloadItems([])
  };
  const deleteList = async () => {
    // if (window.confirm("Do you want to delete?")) {
    if (!selectedToDelete) return;
    let postData = {
      videoIds: [selectedToDelete.video_id],
      userId: props.userData.userId
    };
    try {
      const { data: responseData } = await apiCallingPost("api/video/deleteVideo", postData);
      if (responseData.success === "1") {
        toast.success(MSG.mediaDeleted);
        setTimeout(() => {
          //props.getData("", "");
          setSelectedToDelete(null);
        }, 1000);
      } else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      console.error("Error Deleting Video:", error);
    }
    deletePopupCancel();
    // }
  };
  const listPopup = useCallback((data, mode, index) => {
    setPopupList(true);
    setMode(mode);
    setSelectIndex(index);
    setSelectData(data);
    document.body.style.overflow = 'hidden';
  }, []);
  const cancelPopup = () => {
    setPopupList(false);
    setPopupReject(false);
    setTagPopupFlag(false);
    setIsShareLink(false);
    setIsDownload(false)
    setIsMp4check(false);
    setIsOriginalCheck(false)
    setIsVideoFormatSelect(true)
    setShareRecipientEmail("")
    setShareMessage("")
    document.body.style.overflow = 'auto';
    setVideoIDsIndividual([])

  };
  const linkCopy = (ids, mode, list, index) => {
    if (!isOriginalCheck && !isMp4Check && isDownload && hasVideo) {
      setIsVideoFormatSelect(false)
      document.getElementById("originalVedioCheck")
      return;
    } else {
      if (isDownload) {
        setIsVideoFormatSelect(true)
      }
      setShareMode("Viewer")

      const uniqueArr = [...new Set(ids)];
      // let videoIds = (ids.length > 0 ? ids : videoIDsIndividual)
      let videoIds = (videoIDsIndividual.length > 0 ? videoIDsIndividual : ids)

      shareMedia(videoIds, urlRef.current, mode)
      const shareElement = document.getElementById("link-copy-common");
      if (shareElement && isVideoFormatSelect) {
        shareElement.classList.toggle("d-none");
        setTimeout(() => {
          shareElement.classList.toggle("d-none")
          cancelPopup()
        }
          , 1500);
      }
      navigator.clipboard.writeText(urlRef.current)
        .then(() => {
          // setCopiedIndex(list.video_id);
          setTimeout(() => {
            setCopiedIndex(null)
            // setSelectedVideoIds([])
            // setSelectedItems([])
          }
            , 1500);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }

  };
  const shareMedia = async (ids, url, mode, heading, encodedBody, index) => {
    let postData = {
      videoId: ids,
      encodedVideoUrl: url,
      mode: shareMode,
      downloadOriginal: isOriginalCheck,
      downloadMp4: isMp4Check,
      ...(mode === 'mail' && shareRecipientEmail && {
        shareType: 'mail',
        recipientEmail: shareRecipientEmail,
        message: shareMessage
      })
    };

    try {
      const { data: responseData } = await apiCallingPost("api/video/saveShareRequest", postData);

      if (responseData.success === "1") {
        if (mode === 'mail') {
          toast.success(MSG.shareEmailSent);
          cancelPopup();
        }
        if (index !== undefined) {
          setPopupShareStates((prevStates) => ({
            ...prevStates,
            [index]: !prevStates[index],
          }));
        }
      } else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      // A refused or failed save means the copied/sent link will not open: say so.
      console.error("Error saving share:", error);
      toast.error(MSG.genericError);
    }
  }
  const listSharePopup = async (ids, mode, list, index) => {

    const heading = list?.video_heading || '';
    const description = list?.description || '';
    let body = '';

    if (index !== undefined) {
      body = `Hi,

       ${heading}

        ${description ? `Description: ${description}\n\n` : ''}
        View it here: ${urlRef.current}

        Best regards,
        Qatar`;
    } else {
      body = `Hi,
        View it here: ${urlRef.current}

        Best regards,
        Qatar`;
    }

    const encodedBody = encodeURIComponent(body);
    shareMedia(ids, urlRef.current, mode, heading, encodedBody, index)
  };

  // Stable callbacks passed to VideoCard — per-card share/delete actions
  const handleDelete = useCallback((data) => {
    setSelectedToDelete(data);
    setIsDelete(true);
  }, []);

  const handleShare = useCallback((data) => {
    setVideoIDsIndividual([data.video_id]);
    setIsShareLink(true);
    setHasVideo(data.file_type_id === 2);
    urlRef.current = newShareLink();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getTotalSizeMB = (mb) => {
    if (mb >= 1024 * 1024) return `${(mb / (1024 * 1024)).toFixed(2)} TB`;
    if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
    return `${mb} MB`;
  };
  // Clear BOTH selection families (the checkbox feeds share/edit AND download
  // sets), so every checkbox unchecks and the bar disappears.
  const clearDownloadSelection = () => {
    dispatch(clearSelection());
    setHasVideo(false);
    const shareElement = document.getElementById("share-common");
    if (shareElement) {
      shareElement.classList.add("d-none");
    }
  };
  const handleVideoQualityChange = (videoId, selectedQuality, sizes) => {
    const selectedVideoSize = sizes.find(q => q.qualitytype === selectedQuality)?.qualityvideosize || 0;

    setSelectedQualities(prev => {
      const updated = {
        ...prev,
        [videoId]: { quality: selectedQuality, size: selectedVideoSize }
      };
      // Update total size
      const totalSizeMB = downloadSet.reduce((sum, video) => {
        const selected = updated[video.video_id];
        return sum + (selected?.size ? Number(selected.size) : Number(video.size.split(' ')[0]));
      }, 0);
      const formattedSize = getTotalSizeMB(totalSizeMB.toFixed(2));
      setTotalFileSize(formattedSize);
      setTotalFileSizeMb(totalSizeMB);
      return updated;
    });
  };
  const { isLocked, runLocked } = useDownloadLock();
  const handleSingleDownload = (video, selectedQualityObj) => runLocked(video.video_id, async () => {
    const resolutionType = selectedQualityObj?.quality === "Download Original" || !selectedQualityObj?.quality
      ? ""
      : selectedQualityObj.quality;
    const requestPayload = [{
      fileId: video.video_id,
      type: resolutionType
    }];
    try {
      const { responseData } = await prepareDownload(requestPayload, null);
      startBrowserDownload(responseData, `${video.fileName}.${video.file_extension}`);
      toast.success(MSG.downloadStarted);
    } catch (err) {
      console.error("Single download failed", err);
      toast.error(MSG.downloadFailed);
    }
  });
  const handleDownloadAll = () => runLocked('all', async () => {
    try {
      const selectedResolutionArray = getSelectedQualityArray();
      const { responseData } = await prepareDownload(selectedResolutionArray, null);
      startBrowserDownload(responseData, "video.zip");
      toast.success(MSG.downloadStarted);
    } catch (err) {
      console.error("Bulk download failed", err);
      toast.error(MSG.downloadFailed);
    }
  });
  const getSelectedQualityArray = () => {
    return downloadSet.map((video) => {
      const selected = selectedQualities[video.video_id];
      return {
        fileId: video.video_id,
        type: selected?.quality === "Download Original" || !selected?.quality ? "" : selected.quality,
      };
    });
  };

  // After the selection shrinks: the share flow's "has a video" flag follows
  // the selection (a single-file share sets it on its own), and the share
  // panel closes.
  const afterDeselect = useCallback(() => {
    setHasVideo(selectSelectedItems(store.getState()).some(item => item.type_flag === 2));
    const shareElement = document.getElementById("share-common");
    if (shareElement) {
      shareElement.classList.add("d-none");
    }
  }, [store]);
  const removeFromSelection = useCallback((videoId) => {
    dispatch(removeVideo(videoId));
    afterDeselect();
  }, [dispatch, afterDeselect]);
  // A segment row (search by segment) is keyed by its own id and the store
  // keeps its video selected while any segment is ticked; a plain row stands
  // for the whole video, so unticking it drops every row of that video.
  const handleCheckboxChange = useCallback((e, videoId, fileTypeId, id, videoObj) => {
    setVideoIDsIndividual([])
    const isSegment = (videoId != id);   // eslint-disable-line eqeqeq
    if (!e.target.checked && !isSegment) { removeFromSelection(videoId); return; }
    dispatch(toggleRow({ videoId, segmentId: isSegment ? id : undefined, typeFlag: fileTypeId, row: videoObj, checked: e.target.checked }));
    if (e.target.checked) setHasVideo(selectSelectedItems(store.getState()).some(item => item.type_flag === 2));
    else afterDeselect();
  }, [dispatch, store, afterDeselect, removeFromSelection]);
  // Toolbar action (project-based requests, 2026-09-23). Two branches and no
  // per-asset triage: cards carry no request status any more (one file can sit
  // in several requests), so the whole selection is either downloaded outright
  // — staff / full access, the same rule as the server's downloadAuth — or
  // requested as ONE new request under a project. Requesting a file that is
  // already pending or approved elsewhere is allowed: that is another project.
  const downloadMultiple = () => {
    if (canDownloadDirect) {
      // a fresh array: the selector's reference is stable, and the modal's size
      // total must recompute on every open (the Single modal overwrites it)
      setDownloadSet([...selectedDownloadVideoALL]);
      setIsMultipleDownload(true);
      return;
    }
    const videoIds = selectedDownloadVideoALL.map((v) => v.video_id);
    setDownloadRequestForm({
      count: videoIds.length,
      // Failures rethrow so the form modal stays open with the user's input
      // (retry or cancel), and always get a toast. Requester and timestamp
      // come from the server's session and clock, not from here.
      submit: async (details) => {
        const postData = { video_id: videoIds, ...details };
        let responseData;
        try {
          ({ data: responseData } = await apiCallingPost("api/video/saveVideoDownloadRequest", postData));
        } catch (error) {
          console.error("Error submitting download request:", error);
          toast.error(MSG.requestFailed);
          throw error;
        }
        if (responseData.success !== "1") {
          toast.error(MSG.requestFailed);
          throw new Error("saveVideoDownloadRequest failed");
        }
        toast.success(MSG.downloadRequestSubmitted);
        return responseData;
      },
      clearSelection: true,
    });
  };
  const deletePopupCancel = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
  }

  //  console.log("🚀 ~ ListShowAll ~ tagListMore:", tagListMore)
  return (
    <div className='list-wrapper my-5'>
      <div className='container'>
        {downloadRequestForm &&
          <DownloadRequestFormModal
            open={true}
            count={downloadRequestForm.count}
            onCancel={() => { setDownloadRequestForm(null); downloadRequestForm.onCancel?.(); }}
            onSubmit={(details) => runDownloadRequestSubmit(downloadRequestForm, details, {
              close: () => setDownloadRequestForm(null),
              clearSelection: clearDownloadSelection,
              onAfterSubmitError: (e) => console.error("Refresh after download request failed:", e),
            })}
          />}

        <DownloadSelectionBar
          count={selectedDownloadVideoALL.length}
          items={selectedDownloadVideoALL.map((v) => ({ key: v.video_id, name: v.fileName }))}
          onRemove={removeFromSelection}
          mode={canDownloadDirect ? "download" : "request"}
          onDownload={downloadMultiple}
          onShare={isStaff ? shareSelection : undefined}
          onClear={clearDownloadSelection}
        />

        {isDelete &&
          <div className="modal-admin-wrapper multiple-upload" >
            <div className="modal-ad-popup modal-md">
              <div className="modal-innerpopup ">
                <div className="modal-headdiv d-flex justify-content-between text-center">
                  <h5 className="modal-head">Deleting this video will also remove the original file and all associated segments. Are you sure you want to proceed?</h5>
                  {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => deletePopupCancel()}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                    onClick={() => deleteList()}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>}
        <div className='row'>
          <div className='col-md-9'>
            {searchText && (
              <>
                {(tagNames.length > 0 && !tagNameFlag) && (
                  <p className='banner-search-text text-start'>
                    Did you mean:
                    {tagNames.map((name, i) => (
                      <span
                        className='f-medium banner-search-text-span'
                        key={i}
                        onClick={() => {
                          // Accepting a suggestion = a new search: first page (the
                          // scroll offset may be >0, and offset>0 APPENDS), and the
                          // suggestion row hides. Same as the banner's handler.
                          dispatch(setSearchText(name));
                          dispatch(setTagNameFlag(true));
                          dispatch(setOffsetTag(0));
                        }}
                      >
                        {name}
                      </span>
                    ))}
                  </p>
                )}
                {tagListIsFallback ? (
                  <p className='text-dark' style={{ fontSize: "20px" }}>
                    No exact match for <span className='theme-color fst-italic'>{searchText}</span>. Showing media that matches some of these words.
                  </p>
                ) : (
                  <p className='text-dark' style={{ fontSize: "20px" }}>
                    These are results for <span className='theme-color fst-italic'>{searchText}</span>
                  </p>
                )}
              </>
            )}

          </div>
          {(selectedVideoIds.length > 0 || videoIDsIndividual.length > 0) && (
            <>
              {isShareLink &&
                <div className="modal-admin-wrapper multiple-upload" >
                  <div className="modal-ad-popup modal-md">
                    <span className="closeBtn closeBtn_file">
                      <IoCloseOutline onClick={() => cancelPopup()} size={32} />
                    </span>
                    <div className="modal-innerpopup">

                      <div className="row mb-3">
                        <div className='col-lg-8 col-6'>
                          <h5 className="modal-head mb-0 text-start mt-2">Anyone with the link</h5>
                        </div>
                        <div className='col-lg-4 col-6 '>
                          <select name="" id="" className='form-control form-select-drop' onChange={(e) => {
                            setShareMode(e.target.value)
                            if (e.target.value === "Download") {
                              setIsDownload(true)
                            } else {
                              setIsDownload(false)
                            }
                          }} >
                            <option value="Viewer" selected >View only</option>
                            <option value="Download">Download</option>
                          </select>
                          {/* {isDownload && */}

                          <div style={{ visibility: isDownload && hasVideo ? 'visible' : 'hidden' }}>
                            <div className="checkbox-wrapper-1 checkbox-list-select d-flex align-items-center gap-3 mt-2">
                              <div className='d-flex align-items-center gap-1'>
                                <input id={`originalVedioCheck`} className="substituted" type="checkbox" aria-hidden="true"
                                  checked={isOriginalCheck}
                                  onChange={(e) => setIsOriginalCheck(e.target.checked)}
                                />
                                <label className=" d-flex align-items-center" htmlFor={`originalVedioCheck`}
                                  style={{ fontSize: '12px' }}
                                >Original</label>
                              </div>
                              <div className='d-flex align-items-center gap-1'>
                                <input id={`mp4Check`} className="substituted" type="checkbox" aria-hidden="true"
                                  checked={isMp4Check}
                                  onChange={(e) => setIsMp4check(e.target.checked)}
                                />
                                <label className=" d-flex align-items-center" htmlFor={`mp4Check`}
                                  style={{ fontSize: '12px' }}
                                >MP4</label>
                              </div>
                            </div>
                            {!isVideoFormatSelect && (<div className='col-lg-8 col-6 d-flex align-items-center'>
                              <h6 className="modal-head mb-0 text-start" style={{ fontSize: '12px', whiteSpace: 'nowrap', color: 'red', fontWeight: 'normal' }}>Please select Video format</h6>
                            </div>)}
                          </div>

                        </div>

                      </div>


                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Recipient email address"
                          value={shareRecipientEmail}
                          onChange={(e) => setShareRecipientEmail(e.target.value)}
                        />
                        <textarea
                          className="form-control mt-2"
                          rows={2}
                          placeholder="Add a message (optional)"
                          value={shareMessage}
                          onChange={(e) => setShareMessage(e.target.value)}
                        />
                      </div>

                      <div className='d-flex align-items-center gap-2'>
                        <button className="addButton add-index addButtonShare link-btns  mx-0 d-flex align-items-center gap-2"
                          style={{ top: 'unset' }}
                          onClick={() => linkCopy(selectedVideoIds, "copy")}
                        >
                          <FiLink size={17} />Copy link
                          <div
                            className="d-none position-absolute ms-0 mt-5 px-2 py-1 text-white bg-dark rounded"
                            id="link-copy-common" style={{ fontSize: "10px", zIndex: 10, width: "53px" }}
                          >
                            Copied!
                          </div>
                        </button>
                        <button
                          className="addButton add-index addButtonShare link-btns mx-0 d-flex align-items-center gap-2"
                          style={{ top: 'unset' }}
                          disabled={!shareRecipientEmail}
                          onClick={() => {
                            if (shareRecipientEmail) listSharePopup(videoIDsIndividual.length > 0 ? videoIDsIndividual : selectedVideoIds, "mail");
                          }}
                        >
                          <FiMail size={17} />Share by Email
                        </button>
                      </div>

                    </div>
                  </div>
                </div>}
            </>
          )}

          {isMultipleDownload &&
            <div className="modal-admin-wrapper" >
              <div className="modal-ad-popup modal-md">
                <div className="modal-innerpopup ">
                  <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span>
                  <div className="modal-headdiv d-flex justify-content-between">
                    <h5 className="modal-head">Download Files!</h5>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <div className="d-flex align-items-center gap-2"> <BiFile /><strong>{downloadSet.length} file(s), {totalFileSize} </strong></div>
                    </div>
                    <LargeBundleNote totalMb={totalFileSizeMb} />
                  </div>
                  <div className="modal-admin-body my-3" style={{ maxHeight: 'calc(100vh - 290px)' }}>
                    <div className="table-responsive">

                      <table className="table table-bordered admin-list-table">
                        <tbody>
                          {downloadSet.map((data, i) => {

                            return (
                              < tr key={i} >
                                <td style={{ width: '40%', minWidth: '250px' }} className='text-start'>{data.video_heading}{"." + data.file_extension}</td>
                                <td style={{ width: '20%', minWidth: '100px' }} className='text-center'>
                                  {selectedQualities[data.video_id]?.size
                                    ? `${selectedQualities[data.video_id].size} MB`
                                    : (data.download_mp4 && !data.download_original) ? `${data.qualityTypeArray[0].qualityvideosize} MB` : `${data.size} MB`} </td>


                                <td style={{ width: '40%', minWidth: '250px' }} className='text-center'>
                                  {props.userData.roleDisplayName === "User" &&
                                    // (data.downloadStatus === "APPROVED" ?
                                    <div className="d-flex align-items-center gap-3"
                                      style={{ color: '#00627B' }}
                                    >
                                      <select name="" id="" className='form-control form-select-drop'
                                        value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                        onChange={(e) =>
                                          handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                        }
                                      >
                                        {(data.download_original || canDownloadDirect) &&
                                          <option value="Download Original" >Download Original</option>}
                                        {(data.download_mp4 || canDownloadDirect) &&
                                         data.qualityTypeArray
                                         ?.filter(
                                           (obj) => (                                                      
                                               (
                                                 obj.qualitytype !== "" &&
                                                 obj.qualitytype !== "unknown" && obj.qualitytype !== "undefined")
                                           ))
                                         .map((obj, j) => (
                                           <option key={j} value={obj.qualitytype}>
                                             {obj.qualitytype}
                                           </option>
                                         ))}
                                          {/* // data.qualityTypeArray.map((obj, j) => (
                                          //   <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                          // ))} */}
                                      </select>

                                      <span

                                        style={{ flex: 'none', opacity: isLocked(data.video_id) ? 0.5 : 1, cursor: isLocked(data.video_id) ? 'default' : 'pointer' }}

                                        onClick={() => !isLocked(data.video_id) && handleSingleDownload(data, selectedQualities[data.video_id])}>

                                        {isLocked(data.video_id)

                                          ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />

                                          : <FaDownload />}</span>
                                    </div>
                                    // : "Waiting for Approval")
                                  }
                                  {['Admin', 'Super_admin', 'APPROVER'].includes((props.userData?.roleDisplayName)) &&

                                    <div className="d-flex align-items-center gap-3"
                                      style={{ color: '#00627B' }}
                                    >
                                      <select name="" id="" className='form-control form-select-drop'
                                        value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                        onChange={(e) =>
                                          handleVideoQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                        }
                                      >

                                        <option value="Download Original" >Download Original</option>
                                        {
                                          data.qualityTypeArray
                                          ?.filter(
                                            (obj) => (                                                      
                                                (
                                                  obj.qualitytype !== "" &&
                                                  obj.qualitytype !== "unknown" && obj.qualitytype !== "undefined")
                                            ))
                                          .map((obj, j) => (
                                            <option key={j} value={obj.qualitytype}>
                                              {obj.qualitytype}
                                            </option>
                                          ))}
                                        {/* {
                                          data.qualityTypeArray.map((obj, j) => (
                                            <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                          ))} */}
                                      </select>

                                      <span

                                        style={{ flex: 'none', opacity: isLocked(data.video_id) ? 0.5 : 1, cursor: isLocked(data.video_id) ? 'default' : 'pointer' }}

                                        onClick={() => !isLocked(data.video_id) && handleSingleDownload(data, selectedQualities[data.video_id])}>

                                        {isLocked(data.video_id)

                                          ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />

                                          : <FaDownload />}</span>
                                    </div>

                                  }
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="tag-popup-footer">
                    {!isDownloadBtn &&
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          className="accept-all-btn w-100 py-2 accept-all-gray"
                          onClick={() => cancelpopup()}
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                          onClick={() => handleDownloadAll()}
                          disabled={isLocked('all')}
                        >
                          {isLocked('all')
                            ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> Starting…</>
                            : <>Download all <BiDownload className="ms-0" /></>}
                        </button>
                      </div>}
                  </div>
                </div>
              </div>
            </div>}


          {tagListMore.length > 0 && (
            <div className="col-md-3 filter-section mb-3 filert-view-mobile">
              {selectedDownloadVideoALL.length > 0 &&

                <button className="btn-listing-btn" onClick={() => downloadMultiple()}
                // onClick={() => downloadAll()}
                >
                  {/* {isLoading ?
    (<RiLoader4Fill className="loader-icon" />) : */}
                  <HiDownload />
                  {/* } */}
                </button>}

              <div className='list-grid-btns'>
                <div
                  className={`list-grid-div ${viewType === 'grid' ? 'active' : ''}`}
                  onClick={() => dispatch(setViewType('grid'))}
                >
                  <div className='grid-fill'>
                    <div className='grid-inner-fill'>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                    </div>
                    <div className='grid-inner-fill'>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                    </div>
                    <div className='grid-inner-fill'>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                      <div className='grid-dot-fill'></div>
                    </div>
                  </div>
                </div>
                <div
                  className={`list-grid-div ${viewType === 'list' ? 'active' : ''}`}
                  onClick={() => dispatch(setViewType('list'))}
                >
                  <div className='list-bar'>
                    <div className='inner-list-bar'></div>
                    <div className='inner-list-bar'></div>
                    <div className='inner-list-bar'></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          {viewType === 'grid' ? (
            <Virtuoso
              ref={virtuosoRef}
              useWindowScroll
              totalCount={gridRowCount}
              endReached={handleLoadMore}
              itemContent={renderGridRow}
              className="list"
            />
          ) : (
            <Virtuoso
              ref={virtuosoRef}
              useWindowScroll
              className="list row g-4 row-cols-1 list-view-div"
              totalCount={tagListMore.length}
              components={{ Item: ListItem }}
              endReached={handleLoadMore}
              itemContent={renderVideoCard}
            />
          )}
          {loadingTag &&
            <div className="d-flex flex-column text-center">
              <div>
                <img src={Loader} alt="noData" className="img-fluid" width="100" height="100" />
              </div>
            </div>
          }
          {((!loadingTag) && tagListMore.length === 0) &&
            <div className="d-flex flex-column text-center pt-3">
              <div>
                <p>No data found</p>
              </div>
            </div>
          }
        </div>
      </div>
      <MediaPreview
        open={tagPopupFlag}
        url={selectedData.url}
        fileType={selectedData.file_type_id}
        qualityTypeArray={selectedData.qualityTypeArray}
        poster={selectedData.thumbnail_image}
        onClose={cancelpopup}
        onPlay={() => { if (!props.isAuthenticated) window.location.href = '/login'; }}
      />
      {popupList &&
        <ListUpload userData={props?.userData}
          cancelPopup={cancelPopup} getData={props.getData} getCloudBucketData={props.getCloudBucketData}
          selectData={selectData} mode={mode} selectIndex={selectIndex} />
      }
    </div>
  );
}

export default ListShowAll;